export default {
  paddingTop: '2px',
  cursor: 'pointer',
};



// WEBPACK FOOTER //
// ./src/common/CheckBox/style.js